var _style, _desc, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 5.3 9.3",
    style: {
      enableBackground: "new 0 0 5.3 9.3"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_xD83C__xDF6D_-Icon",
    className: "st0",
    d: "M0.2,8.2c-0.3,0.3-0.3,0.7,0,0.9c0.3,0.3,0.7,0.3,0.9,0l4-4c0.3-0.3,0.3-0.7,0-0.9 l-4-4c-0.3-0.3-0.7-0.3-0.9,0c-0.3,0.3-0.3,0.7,0,0.9l3.5,3.5L0.2,8.2z"
  })));
}

export default "data:image/svg+xml,export default 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjEuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1LjMgOS4zIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1LjMgOS4zOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO30KPC9zdHlsZT4KPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgo8cGF0aCBpZD0iX3hEODNDX194REY2RF8tSWNvbiIgY2xhc3M9InN0MCIgZD0iTTAuMiw4LjJjLTAuMywwLjMtMC4zLDAuNywwLDAuOWMwLjMsMC4zLDAuNywwLjMsMC45LDBsNC00YzAuMy0wLjMsMC4zLTAuNywwLTAuOQoJbC00LTRjLTAuMy0wLjMtMC43LTAuMy0wLjksMGMtMC4zLDAuMy0wLjMsMC43LDAsMC45bDMuNSwzLjVMMC4yLDguMnoiLz4KPC9zdmc+Cg=='";
export { SvgChevronRight as ReactComponent };